const prefix = 'sectors/'

export const GET_ALL_SECTORS = `${prefix}get/all`
export const UPDATE_SINGLE_SECTOR = `${prefix}patch/single`
